import React, { useEffect } from 'react'
import {
  HashRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import About from "./pages/About";
import AreaOfInterest from "./pages/AreaOfInterest";
import Checkout from "./pages/Checkout";
import NoScreen from "./pages/NoScreen";
import ContactUs from "./pages/ContactUs";
import Changepassword from "./pages/Changepassword";
import Createnewpassword from "./pages/Createnewpassword";
import Afcrnewpass from "./pages/Afcrnewpass";
import Dashboard from "./pages/Dashboard";
import Feedback from "./pages/Feedback";
import ForgotPassword from "./pages/ForgotPassword";
import Home from "./pages/Home";
import Login from "./pages/Login";
import MyAccount from "./pages/MyAccount";
import ParticipateInWorkshop from "./pages/ParticipateInWorkshop";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Questionnaire from "./pages/Questionnaire";
import Register from "./pages/Register";

const App = () => {
  const [screenWidth, setScreenWidth] = React.useState(window.innerWidth)
  useEffect(() => {
    
    function handleResize() {
     
        setScreenWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    window.addEventListener('load', handleResize)
    
  },[screenWidth])
  if(screenWidth < 768) {
    return <NoScreen />
  }
  return (

    <Router >
      <div className="font-body">
        <Switch>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/area-of-interest">
            <AreaOfInterest/>
          </Route>
          <Route path="/questionnaire/:type/:step/:id">
            <Questionnaire />
          </Route>
          <Route path="/my-account">
            <MyAccount />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/register">
            <Register/>
          </Route>
          <Route path="/forgot-password">
            <ForgotPassword/>
          </Route>
          <Route path="/change-password">
            <Changepassword/>
          </Route>
          <Route path="/create-new-password">
            <Createnewpassword/>
          </Route>
          <Route path="/afcrnewpass">
            <Afcrnewpass/>
          </Route>
          <Route path="/privacy-policy">
            <PrivacyPolicy/>
          </Route>
          <Route path="/connect/contact-us">
            <ContactUs/>
          </Route>
          <Route path="/connect/feedback">
            <Feedback />
          </Route>
          <Route path="/connect/participate-in-workshop">
            <ParticipateInWorkshop />
          </Route>
          <Route path="/dashboard/:needsassesmentid">
            <Dashboard/>
          </Route>
          <Route path="/checkout">
            <Checkout/>
          </Route>
          <Route path="/">
            <Home />
          </Route>
          <Route path="*" component={()=>"404 NOT FOUND"}>
          </Route>
        </Switch>
      </div>
    </Router>

  );
}

export default App;
